export const FunctionalityToggle = Object.freeze({
  CONSUMER_CHOICE: 'b2cConsumerChoiceToggle',
  LOCALLY_ARCHIVED_PRODUCT_LOCATOR_TOGGLE: 'b2cLocallyArchivedProductLocatorToggle',
  LOCALLY_FIND_IN_STORE_BTN_TOGGLE: 'b2cLocallyFindInStorebtnToggle',
  TREKU_EMPLOYEE_PURCHASE_USER_MGMT: 'b2bEmployeePurchaseTrekUUserMgmtToggle',
  ADDRESS_AUTOFILL: 'b2cAddressVerificationServiceToggle',
  TREKU_EMPLOYEE_PURCHASE_ENABLED: 'b2bEmployeePurchaseTrekUCheckoutToggle',
  FDP_CUSTOMIZATION_TOGGLE: 'b2cFDPCustomizationToggle',
  RETAILER_PRICE_NOTE_TOGGLE: 'retailerPriceNoteToggle',
  NEW_LOWER_PRICE_BADGE_TOGGLE: 'newLowerPriceBadgeToggle',
});
